
import React from 'react';

const Services = () => {
  const services = [
    {
      icon: "ri-heart-line",
      title: "Mariages",
      description: "Créez des souvenirs inoubliables avec nos menus de mariage sur mesure. De l'apéritif au dessert, chaque détail est pensé pour sublimer votre jour J.",
      image: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/c8a366415c8f04c9f73ebaa227f3fa80.png",
      features: [
        "Menu personnalisé selon vos goûts",
        "Service complet avec personnel",
        "Décoration de table incluse"
      ]
    },
    {
      icon: "ri-building-line",
      title: "Événements corporate",
      description: "Impressionnez vos clients et collaborateurs avec nos prestations haut de gamme. Séminaires, lancements de produits, galas d'entreprise.",
      image: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/b7d1dbfd51e516cd56149f13e2513d1b.jpeg",
      features: [
        "Cocktails et buffets d'affaires",
        "Service professionnel discret",
        "Adaptation aux contraintes horaires"
      ]
    },
    {
      icon: "ri-group-line",
      title: "Réceptions privées",
      description: "Anniversaires, baptêmes, communions... Nous transformons vos célébrations familiales en moments d'exception avec notre savoir-faire culinaire.",
      image: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/d0abe5b389c48529dc9c116a725f60ec.jpeg",
      features: [
        "Ambiance chaleureuse et conviviale",
        "Menus adaptés à tous les âges",
        "Formules flexibles selon budget"
      ]
    }
  ];

  return (
    <section id="prestations" className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8" style={{ fontFamily: 'Alice, serif' }}>
            Nos Prestations
          </h2>
          
          <div className="flex items-center justify-center mb-8">
            <div className="w-24 h-px bg-gray-300"></div>
            <div className="w-4 h-4 bg-gray-300 rounded-full mx-6 rotate-45"></div>
            <div className="w-24 h-px bg-gray-300"></div>
          </div>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            De l'intime au grandiose, nous orchestrons vos événements avec passion et savoir-faire
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="bg-black/50 backdrop-blur-sm rounded-lg overflow-hidden border border-gray-400/20 hover:border-gray-300/40 transition-all duration-300 group flex flex-col h-full">
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute top-4 left-4 w-12 h-12 bg-gradient-to-r from-gray-600 to-gray-400 rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-black text-xl`}></i>
                </div>
              </div>

              {/* Contenu */}
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-gray-300 mb-4" style={{ fontFamily: 'Alice, serif' }}>
                  {service.title}
                </h3>
                
                <p className="text-gray-400 mb-6 leading-relaxed flex-grow">
                  {service.description}
                </p>

                <div className="mb-6">
                  <ul className="space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-gray-300">
                        <i className="ri-check-line text-gray-400 mr-3"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
